import React from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
    const navigate = useNavigate();

    // Hol den Namen aus dem LocalStorage. Falls keiner da ist, nimm "Kollege"
    const userName = localStorage.getItem('userName') || 'Kollege';

    // Beispiel-Daten für die Statistik-Kacheln
    const stats = [
        { label: 'Aktive Module', value: '2', color: 'bg-blue-500' },
        { label: 'Analysen Heute', value: '0', color: 'bg-emerald-500' },
        { label: 'Systemstatus', value: 'Bereit', color: 'bg-amber-500' },
    ];

    return (
        <div className="max-w-6xl mx-auto">
            {/* Header Sektion */}
            <header className="mb-10">
                <h1 className="text-4xl font-extrabold text-slate-800 tracking-tight">
                    Guten Tag, {userName}!
                </h1>
                <p className="text-lg text-slate-500 mt-2">
                    Willkommen im zentralen Klinik-Portal. Alle Systeme sind betriebsbereit.
                </p>
            </header>

            {/* Statistik-Leiste */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 flex items-center gap-4">
                        <div className={`w-12 h-12 ${stat.color} rounded-xl flex items-center justify-center text-white text-xl`}>
                            {index === 0 ? '🧩' : index === 1 ? '📈' : '✅'}
                        </div>
                        <div>
                            <p className="text-sm font-medium text-slate-500">{stat.label}</p>
                            <p className="text-2xl font-bold text-slate-800">{stat.value}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modul-Auswahl */}
            <h2 className="text-xl font-bold text-slate-800 mb-6">Verfügbare Module</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

                {/* Bayes Modul Karte */}
                <div
                    onClick={() => navigate('/bayes')}
                    className="group cursor-pointer bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-blue-400 transition-all duration-300"
                >
                    <div className="flex justify-between items-start mb-4">
                        <div className="bg-blue-50 p-4 rounded-2xl text-3xl group-hover:scale-110 transition-transform">🧠</div>
                        <span className="bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full uppercase">Aktiv</span>
                    </div>
                    <h3 className="text-2xl font-bold text-slate-800 mb-2">Bayes-Inferenz</h3>
                    <p className="text-slate-600 mb-6">
                        Berechnen Sie Wahrscheinlichkeiten für Diagnosen basierend auf klinischer Evidenz und Sensitivitätsdaten.
                    </p>
                    <div className="flex items-center text-blue-600 font-semibold">
                        Modul öffnen <span className="ml-2 group-hover:translate-x-2 transition-transform">→</span>
                    </div>
                </div>

                {/* GefäßKalkulator Karte */}
                <div
                    onClick={() => navigate('/gefaess')}
                    className="group cursor-pointer bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-rose-400 transition-all duration-300"
                >
                    <div className="flex justify-between items-start mb-4">
                        <div className="bg-rose-50 p-4 rounded-2xl text-3xl group-hover:scale-110 transition-transform">🩺</div>
                        <span className="bg-rose-100 text-rose-700 text-xs font-bold px-3 py-1 rounded-full uppercase">Aktiv</span>
                    </div>
                    <h3 className="text-2xl font-bold text-slate-800 mb-2">GefäßKalkulator 2026</h3>
                    <p className="text-slate-600 mb-6">
                        Erlös und Kosten gefäßchirurgischer Eingriffe im Vergleich: stationär (aG-DRG), kurzstationär / Hybrid-DRG und ambulant (AOP/EBM).
                    </p>
                    <div className="flex items-center text-rose-600 font-semibold">
                        Modul öffnen <span className="ml-2 group-hover:translate-x-2 transition-transform">→</span>
                    </div>
                </div>

                {/* Patientenverwaltung Karte (Platzhalter) */}
                <div
                    onClick={() => navigate('/patients')}
                    className="group cursor-pointer bg-slate-50 p-8 rounded-3xl border border-dashed border-slate-300 hover:bg-white hover:border-slate-400 transition-all"
                >
                    <div className="flex justify-between items-start mb-4">
                        <div className="bg-slate-200 p-4 rounded-2xl text-3xl grayscale">👥</div>
                        <span className="bg-slate-200 text-slate-600 text-xs font-bold px-3 py-1 rounded-full uppercase">In Planung</span>
                    </div>
                    <h3 className="text-2xl font-bold text-slate-400 mb-2">Patientendaten</h3>
                    <p className="text-slate-400 mb-6">
                        Zentrale Verwaltung von Patientenfällen und Evidenzverläufen. (Wartet auf Ethik-Votum)
                    </p>
                    <div className="text-slate-400 font-semibold italic">
                        Demnächst verfügbar
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Dashboard;